/**
 * <review-slider> — a horizontal scroll-snap slider driven by two arrow
 * buttons (prev / next). Clicking an arrow scrolls by one card; the buttons
 * disable at the start / end of the track.
 */
class ReviewSlider extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-rr-track]');
    this.prevBtn = this.querySelector('[data-rr-prev]');
    this.nextBtn = this.querySelector('[data-rr-next]');
    if (!this.track) return;

    this.cards = Array.from(this.track.children);

    this.prevBtn?.addEventListener('click', () => this.#scrollByStep(-1));
    this.nextBtn?.addEventListener('click', () => this.#scrollByStep(1));
    this.track.addEventListener('scroll', this.#onScroll, { passive: true });
    this.#update();
  }

  disconnectedCallback() {
    this.track?.removeEventListener('scroll', this.#onScroll);
  }

  #step() {
    if (this.cards.length < 2) return this.track.clientWidth;
    // card width + gap, derived from the first two cards' offsets
    return this.cards[1].offsetLeft - this.cards[0].offsetLeft;
  }

  #scrollByStep(dir) {
    this.track.scrollBy({ left: dir * this.#step(), behavior: 'smooth' });
  }

  #onScroll = () => {
    clearTimeout(this._t);
    this._t = setTimeout(this.#update, 60);
  };

  #update = () => {
    const { scrollLeft, scrollWidth, clientWidth } = this.track;
    const atStart = scrollLeft <= 1;
    const atEnd = scrollLeft + clientWidth >= scrollWidth - 1;
    if (this.prevBtn) this.prevBtn.disabled = atStart;
    if (this.nextBtn) this.nextBtn.disabled = atEnd;
  };
}

if (!customElements.get('review-slider')) {
  customElements.define('review-slider', ReviewSlider);
}
